<div class="d-flex align-items-center gap-3">
    <h5 class="text-primary font-semibold f-14 mb-0 p-2 mt-1">
        Product List
    </h5>
    <ng-container *ngIf="itemSectionModel.showImportAndDownloadFile && showImportAndDownloadFile">
        <div>
            <app-button (click)="fileInput.click()" class="" [buttonLabel]="'Import'"  showUploadIconWhite="true" [buttonClass]="'blue_button'"
            [buttonType]="'button'" >
            </app-button>
            <input class="d-none" type="file" #fileInput (change)="onFileSelect($event)" accept=".xls,.xlsx"/>
        </div>
        <div class="ms-3 col d-flex justify-content-end" >
            <a (click)="downloadExcel()" class="text-primary font-semibold f-14 cursorPointer ">Download Sample File</a>
        </div>
    </ng-container>
    <ng-container *ngIf="itemSectionModel.showImportAndSampleFile">
        <div class="col d-flex justify-content-start mb-1 align-items-center gap-2 me-1">
            <div *ngIf="fileName" class="d-flex gap-2 mt-2 align-items-center">
                <app-svg-icon [name]="'cross'" (click)="clearFiles()" class="cross-button cursorPointer"></app-svg-icon>
                <!-- <div class="d-block text-center my-auto text-primary text-truncate font-regular me-2 ps-1 " [title]="fileName" style="max-width: 150px;" style="max-width: 150px;">{{fileName}}</div> -->
                <div class ="d-block" [ngbTooltip]="fileName"  placement="auto" container="body" >
                  <app-svg-icon name="importFile" class="cursorPointer" (click)="uploadFile()"></app-svg-icon>
                </div>
              </div>
            <div class="addImportdropdown">
                <div ngbDropdown class="d-inline-block">
                    <button type="button" class="btn blue_button" id="dropdownBasic1" ngbDropdownToggle>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12.798" height="12.484"
                                viewBox="0 0 13.798 14.484">
                                <path id="Union_222" data-name="Union 222"
                                    d="M2855.64,19153.484c-.461,0-.534-.072-.534-.545v-3.7c0-.234.1-.393.346-.389s.341.168.341.4v3.5h8.643v-7.689h-3.73c-.582,0-.644-.059-.644-.625v-3.711h-4.269v4.537c0,.092.034.207-.01.27-.1.115-.221.273-.346.283-.1.01-.226-.164-.322-.273-.034-.043-.01-.135-.01-.207v-4.812c0-.441.082-.523.524-.523,1.548,0,3.091,0,4.634.01a.794.794,0,0,1,.5.2c1.389,1.359,2.759,2.74,4.144,4.109a.824.824,0,0,1,.26.635q-.007,3.987,0,7.971c0,.471-.087.563-.558.563Zm5.153-9.145h3.076l-3.076-3.1Zm-3.73,5.98a.739.739,0,0,1,.072-1.053c.409-.369.832-.721,1.322-1.148h-.375c-1.634,0-3.269,0-4.9,0a.748.748,0,0,1-.764-.986.758.758,0,0,1,.8-.508q2.437-.009,4.874-.006h.375c-.471-.4-.88-.75-1.279-1.105a.744.744,0,0,1,.88-1.2c1,.826,1.971,1.672,2.937,2.533a.706.706,0,0,1-.019,1.066c-.952.842-1.918,1.674-2.889,2.494a.705.705,0,0,1-.464.174A.757.757,0,0,1,2857.063,19150.32Z"
                                    transform="translate(-2851.869 -19139.5)" fill="#5843CF" stroke="rgba(0,0,0,0)"
                                    stroke-miterlimit="10" stroke-width="1" />
                            </svg>
                        </span>
                        <span class="f-14 font-semibold ms-1 align-items-center cursorPointer">
                            Import
                        </span>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                        <div class="form-check d-flex" ngbDropdownItem>
                            <div class="d-flex align-items-center"><app-svg-icon name="import"
                                    class="cursorPointer"></app-svg-icon></div>
                            <input #importFile type="file" id="import" name="import" (change)="onFileSelected($event)"
                                class="d-none" accept=".xls,.xlsx">
                            <label for="import"
                                class="d-flex align-items-center mb-0 f-12 ps-1 font-regular cursorPointer color-dark-gray mb-0">
                                Import
                            </label>
                        </div>
                        <div class="form-check d-flex" ngbDropdownItem (click)="onClickSampleFile()">
                            <div class="d-flex align-items-center"><app-svg-icon name="importsample"
                                    class="cursorPointer"></app-svg-icon></div>
                            <label for="sample"
                                class="d-flex align-items-center mb-0 f-12 ps-1 cursorPointer font-regular color-dark-gray mb-0 f-12">
                                Sample
                            </label>
                        </div>
                    </div>
                </div>
                <div class="add_import_button" (click)="toggleDropdown()">
                    <button type="button" class="btn d-flex gap-2 p-0" id="import">
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
</div>



<div class="item_list_table position-relative">
    <app-ag-grid     
        class="ag-theme-alpine" 
        [dataModel]="agGridDataModelItemList"
        [tableRowCellEditable]="false"
        [columnSettings]="true" 
        [rowHeight]="27"
        (onEditIconClick)="onEditIconClick($event)"
        (imgCellClicked)="imgCellClicked($event)"
        (barcodeCellClicked)="confirmPrintPopUp($event)"
        (gridReady)="onGridReady($event)"
        (onDeleteIconClick)="onDeleteIconClick($event)"
        >
    </app-ag-grid>
</div>